import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';

import { isCurrentUserProfileOwner } from '../../../selectors/users';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { getUsersByIds } from '@wix/da-shared-react/pkg/redux/users/selectors';
import { VISITOR_IDS_STREAM } from '../../../streams';
import { Props } from './RecentVisitors';

type StateProps = Pick<Props, 'visitors' | 'isOwner'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const visitors = getUsersByIds(
    state,
    streamSelectors.getItems(state, VISITOR_IDS_STREAM)
  );
  const isOwner = isCurrentUserProfileOwner(state);
  return { visitors, isOwner };
};

export default connect(mapStateToProps);
